var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoing02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 34.9027V19.5277M19.5 34.9027L15.2292 31.4861M19.5 34.9027L23.7708 31.4861M7.59975 12.8943C5.98403 13.3009 4.57237 14.2834 3.63002 15.6574C2.68766 17.0314 2.27946 18.7022 2.48211 20.3559C2.68476 22.0096 3.48431 23.5325 4.73054 24.6382C5.97678 25.744 7.58391 26.3567 9.25 26.3611H10.9583",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0429 9.51351C25.459 7.2014 24.0178 5.19782 22.0115 3.90891C20.0051 2.62 17.5837 2.1422 15.2381 2.57238C12.8926 3.00257 10.7983 4.30853 9.37994 6.22554C7.96155 8.14256 7.32515 10.5272 7.59975 12.896C7.59975 12.896 7.86112 14.4028 8.39583 15.2569",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0417 26.3612C29.2478 26.3603 30.4401 26.1041 31.5401 25.6093C32.6401 25.1144 33.6228 24.3923 34.4235 23.4903C35.2243 22.5883 35.8249 21.5269 36.1859 20.3761C36.547 19.2252 36.6601 18.0109 36.518 16.8132C36.3759 15.6154 35.9818 14.4614 35.3615 13.4269C34.7413 12.3925 33.9089 11.5011 32.9194 10.8115C31.9298 10.122 30.8054 9.64976 29.6202 9.42605C28.4349 9.20233 27.2158 9.23216 26.0429 9.51358L23.7708 10.132",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoing02);
export default __webpack_public_path__ + "static/media/joing-02.9c9c6d2c1981c88365d592491e723231.svg";
export { ForwardRef as ReactComponent };